module.exports = __webpack_public_path__ + "img/logo-02.7ce8cb1b.png";